module.exports = __webpack_public_path__ + "img/abc-block.868bc243.png";